import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'; // Import SweetAlert2

import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import withReactContent from 'sweetalert2-react-content'; // Import React components for SweetAlert2
import { useBlogContext } from '../../../fetchdata/BlogContext';

 
import { Helmet } from 'react-helmet';
import getCookie from '../../../helper/getCookie';
import getDecryptData from '../../../helper/getDecryptData';
import HeaderPage from '../../components/HeaderPage';
import NavBar from '../../components/NavBar';
const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components

const Account = () => {
   const { Headers,isHeader} = useBlogContext();

    const decryptdatajson =  getDecryptData();


  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const isLoginFromLocalStorage = localStorage.getItem('token') ? true : false;
  const isLoginFromLocalStorage =  getCookie('token') ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  const [isLoginForm, setIsLoginForm] = useState(true); // State to manage which form to display

  const [IfLogin, setIfLogin] = useState(true); // State to manage which form to display



  const toggleForm = () => {
    setIsLoginForm(prevState => !prevState); // Toggle between login and signup forms
  };


  useEffect(() => {
    // console.log(isLoginFromLocalStorage, 'isLoginFromLocalStorage')

    const checkUserToken = async () => {
      console.log('Effect is running');
      // Check if this is printed multiple times
     
      // const usertoken = localStorage.getItem('token');

      const usertoken =  getCookie('token');
      
      if (!usertoken) {
        toast.error("Please Login First");
        navigate('/');

      }

    }
    checkUserToken();
  }, [dispatch, navigate]);

  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      setPlatform('Android');
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setPlatform('iOS');
    } else {
      setPlatform('Web');
    }
  }, []);


  const [Order, setOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OrderPlace, setOrderPlace] = useState('');
  const [MYuser, setMYuser] = useState('');
    const [formData, setFormData] = useState([]);


  // const userId = localStorage.getItem('userId');
  const userId = getCookie('userId');

  const getUserOrders = async () => {

    try {
  
    const id = decryptdatajson?._id;

      const { data } = await axiosInstance.get(`/user-orders/${id}`);
      // console.log(id);
      if (data?.success) {
        setOrder(data?.userOrder.orders);
        setOrderPlace(data?.userOrder.orders.length)
      }
      setIsLoading(false); // Set loading state to false after fetching data
      setIfLogin(false)
    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state to false in case of an error

    }
  };

  useEffect(() => {
    // This useEffect runs whenever the 'blog' state variable changes
    // console.log(Order); // Log the updated 'blog' state
  }, [Order]); // Dependency array with 'blog' ensures the effect runs when 'blog' state changes


  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }

  const getDriverProfileImage = (driver) => {
    if (!driver?.profile || typeof driver.profile !== "string") {
      return "/assets/img/user.svg";
    }

    if (driver.profile.startsWith("http")) {
      return driver.profile;
    }

    return weburl + driver.profile.replace("public\\", "").replace("public/", "");
  };

  const getDriverRating = (driver) => {
    const averageRating = Number(driver?.driverRating?.averageRating || 0);
    const totalReviews = Number(driver?.driverRating?.totalReviews || 0);

    return {
      averageRating,
      totalReviews,
      label: totalReviews ? `${averageRating.toFixed(1)} (${totalReviews})` : "No reviews",
    };
  };


  useEffect(() => { 
  
    getUserOrders();
  }, []); // Empty dependency array ensures that the effect runs once after the initial render


    const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));

  };



        // Function to handle delete
    const handleCancelOrder = (categoryId) => {
      if(!formData.comment || formData.comment === ''){
     toast.error('Comment is required');
       return null;
      }
  
      const mycomment = `Cancelled by user: ${formData.comment}`;
  
      MySwal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this data!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Cancel it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true,
        customClass: {
          popup: 'custom-swal-popup', // Add a class to the entire dialog
          confirmButton: 'btn-primary', // Add a class to the confirm button
        },
      }).then((result) => {
        if (result.isConfirmed) {
   
      axiosInstance.put(`/cancel-order/${categoryId}`, { comment: mycomment }) 
            .then(() => {
              // Refresh the data or update the state after successful deletion
              getUserOrders();
              toast.success("Cancel Order Successfully!");
            setFormData([]);
  
            })
            .catch((error) => {
              console.error('Error Mark Done:', error);
              toast.error("Error Cancel Order");
   
            });
        }
      });
    };
  

    const [submitLoading, setSubmitLoading] = useState(false);
    const [reviewData, setReviewData] = useState({
      rating: "5",
      comment: "",
    });

  const handleReviewChange = (e) => {
    const { name, value } = e.target;
    setReviewData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleReviewSubmit = async (orderId) => {
    if (!reviewData.rating) {
      toast.error("Rating is required");
      return;
    }

    try {
      const { data } = await axiosInstance.post("/add-order-review", {
        orderId,
        reviewerId: decryptdatajson?._id,
        userId: decryptdatajson?._id,
        rating: Number(reviewData.rating),
        comment: reviewData.comment,
      });

      if (data?.success) {
        toast.success("Review submitted successfully!");
        setReviewData({
          rating: "5",
          comment: "",
        });
        getUserOrders();
        return;
      }

      toast.error(data?.message || "Unable to submit review");
    } catch (error) {
      console.error("Error Submit Review:", error);
      toast.error(error?.response?.data?.message || "Error Submit Review");
    }
  };

  
  const handleSubmit = async (order_id,total) => {

 
    // Start loading before the submission process
    setSubmitLoading(false);
 
      // Prepare data for submission
      const updatedFormData = {
        orderId: order_id,
        totalAmount: total,
       };

      try {

         
        // Send the data to the backend

        const data = await axiosInstance.post(`/order-payment`, updatedFormData);

        console.log('dataaa', data)
        const { success, Order } = data.data;
        if (success) {
 
          console.log('buyPlan',Order)
          const options = {
            key: Headers.keyId,
            amount: total ,
            currency: "INR",
            name: "Drivers24x7",
            description: "Driver24x7 Find Driver Near You!",
            image: Headers.meta_logo,
            order_id: Order.razorpay_order_id,
            callback_url: `${weburl}order-payment-verification`,
            prefill: {
              name: decryptdatajson?.username ?? '' ,
              email:  decryptdatajson?.email ?? '' ,
              contact: decryptdatajson?.phone,
            },
            notes: {
              address: "razorapy official",
            },
            theme: {
              color: "#3399cc",
            },
          };
          const razor = new window.Razorpay(options);
          razor.open();
 

        } else {
          toast.error(data.message || "Something went wrong. Please try again.");
        }
      
 
        
      } catch (error) {
        console.error("Error On payment:", error);
      } finally {
        // Stop loading after the submission process finishes
        setSubmitLoading(true);
      }

 
  };


  return (
    <>
 
 
     <HeaderPage title={'All Orders'} />
 

      <Helmet>
        <title> Account Order | {window.location.hostname}</title>

      </Helmet>
 

 <main className="page-content space-top dz-gradient-shape bg-light">

 
  <div className="px-3 my-1 ">
             
                 

                  {isLoading ? (
          Array.from({ length: 4 }).map((_, index) => (
  <div className="col-md-12" key={index}>
    <div className="order my-3 order-card overflow-visible">

      <div className="row g-3 align-items-start">

        {/* LEFT SIDE */}
        <div className="col-lg-4">
          <div className="order-summary order-left">

            <div className="d-flex gap-2 flex-wrap align-items-center mb-2">
              <div className="skeleton" style={{ width: 150, height: 18, borderRadius: 20 }} />
              <div className="skeleton" style={{ width: 90, height: 24, borderRadius: 20 }} />
              <div className="skeleton" style={{ width: 90, height: 24, borderRadius: 20 }} />
            </div>

            <div className="skeleton" style={{ width: 120, height: 14, borderRadius: 6 }} />

          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-lg-8">
          <div className="d-flex flex-column gap-3">

            <div className="d-flex justify-content-between flex-wrap gap-2">
              
              <div className="skeleton" style={{ width: 140, height: 28, borderRadius: 20 }} />

              <div className="d-flex gap-2">
                <div className="skeleton" style={{ width: 90, height: 32, borderRadius: 20 }} />
                <div className="skeleton" style={{ width: 90, height: 32, borderRadius: 20 }} />
                <div className="skeleton" style={{ width: 90, height: 32, borderRadius: 20 }} />
              </div>

            </div>

            {/* progress dots */}
            <div className="d-flex justify-content-between px-2 pt-2">
              <div className="skeleton" style={{ width: 38, height: 38, borderRadius: "50%" }} />
              <div className="skeleton" style={{ width: 38, height: 38, borderRadius: "50%" }} />
              <div className="skeleton" style={{ width: 38, height: 38, borderRadius: "50%" }} />
              <div className="skeleton" style={{ width: 38, height: 38, borderRadius: "50%" }} />
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
))


                  ) :
                    (Order.map(Order => (
                      <React.Fragment key={Order._id}>


                 <div className="order my-3 bg-light-border order-card overflow-visible">
  <div className="row g-3 align-items-start">
    
    <div className="col-lg-4">
      <div className="order-summary order-left">
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <div className="order-title text-uppercase">
            Order <span className="order-id">#{Order.orderId}</span>
          </div>

          {Order.status !== 7 && (
            <div className="badge-soft badge-otp text-uppercase ms-auto ms-sm-0">
              OTP: <span className="fw-bold">{Order?.OTP ? Order?.OTP : "NA"}</span>
            </div>
          )}

          <div className="badge-soft badge-mode text-uppercase ms-auto">
            {Order.mode}
          </div>
        </div>

        <div className="order-date fs-8">{formatDate(Order.createdAt)}</div>
      </div>
    </div>

    <div className="col-lg-8">
      <div className="d-flex flex-column gap-2">
        
        <div className="d-sm-flex align-items-sm-center justify-content-sm-between gap-2">
          <div className="status order-status">
            <span className="status-label">Status:</span>
            <span className={`status-pill status-${Order.status}`}>
              {Order.status === 0 ? "Cancelled" :
               Order.status === 1 ? "Placed" :
               Order.status === 2 ? "Accepted" :
               Order.status === 3 ? "Scheduled" :
               Order.status === 4 ? "On the Way" :
               Order.status === 5 ? "Started" :
               Order.status === 6 ? "In Progress" :
               Order.status === 7 ? "Completed" :
               Order.status === 8 ? "Reviewed" : "Unknown"}
            </span>
          </div>

          <div className="order-actions d-flex flex-wrap gap-2 justify-content-sm-end mt-2">
            
            {(Order.status !== 0 && Order.status !== 7 && Headers?.ios && Headers?.android) && (
              <button
                type="button"
                className="btn btn-success text-white btn-sm btn-pill"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                Live <i className="fa fa-dot-circle text-white ms-1" aria-hidden="true" />
              </button>
            )}

            {![0, 7, 8].includes(Number(Order.status)) && (
              <div className="dropdown d-inline-block">
                <button
                  className="btn btn-danger dropdown-toggle btn-sm btn-pill"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Cancel Order
                </button>

                <ul className="dropdown-menu p-0 dropdown-card">
                  <div className="p-3 bg-white">
                    <label htmlFor="comment" className="form-label mb-1">
                      Comment <span className="text-danger">(required)</span>
                    </label>
                    <textarea
                      id="comment"
                      className="form-control"
                      name="comment"
                      value={formData.comment}
                      onChange={handleChange}
                      placeholder="Tell us why you want to cancel..."
                      rows={3}
                    />
                    <button
                      className="btn bg-dark text-white btn-sm mt-3 btn-pill w-100"
                      onClick={() => { handleCancelOrder(Order?._id) }}
                    >
                      Submit
                    </button>
                  </div>
                </ul>
              </div>
            )}

            {Order.status === 7 && (
              <div className="dropdown d-inline-block">
                <button
                  className="btn btn-dark dropdown-toggle btn-sm btn-pill text-white"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Review Driver
                </button>

                <ul className="dropdown-menu p-0 dropdown-card">
                  <div className="p-3 bg-white" style={{ minWidth: 260 }}>
                    <label htmlFor={`rating-${Order._id}`} className="form-label mb-1">
                      Rating <span className="text-danger">(required)</span>
                    </label>
                    <select
                      id={`rating-${Order._id}`}
                      className="form-control"
                      name="rating"
                      value={reviewData.rating}
                      onChange={handleReviewChange}
                    >
                   <option value="5">★★★★★ 5 - Excellent</option>
<option value="4">★★★★☆ 4 - Good</option>
<option value="3">★★★☆☆ 3 - Average</option>
<option value="2">★★☆☆☆ 2 - Poor</option>
<option value="1">★☆☆☆☆ 1 - Bad</option>
                    </select>

                    <label htmlFor={`review-comment-${Order._id}`} className="form-label mb-1 mt-2">
                      Comment
                    </label>
                    <textarea
                      id={`review-comment-${Order._id}`}
                      className="form-control"
                      name="comment"
                      value={reviewData.comment}
                      onChange={handleReviewChange}
                      placeholder="Share your driver experience..."
                      rows={3}
                    />
                    <button
                      className="btn bg-dark text-white btn-sm mt-3 btn-pill w-100"
                      onClick={() => { handleReviewSubmit(Order?._id) }}
                    >
                      Submit Review
                    </button>
                  </div>
                </ul>
              </div>
            )}

            {Order.status === 8 && (
              <button className="btn btn-success btn-sm text-white text-uppercase btn-pill" type="button" disabled>
                Reviewed
              </button>
            )}

            {Order.status === 7 && (
              Order.payment === 1
                ? ((Order.paid > Order.totalAmount || Order.paid === Order.totalAmount) ? 
                <button className="btn btn-success btn-sm text-white text-uppercase btn-pill">Paid</button> : 
                <button className="btn btn-dark btn-sm text-white text-uppercase btn-pill" onClick={() => { handleSubmit(Order._id, Order.totalAmount - Order.paid) }}>Pay Now</button>)
                : <button className="btn btn-dark btn-sm text-white text-uppercase btn-pill" onClick={() => { handleSubmit(Order._id, Order.totalAmount) }}>Pay Now</button>
            )}

 
            <Link
              className="btn btn-sm btn-primary text-white text-uppercase btn-pill"
              to={`/account/order/${decryptdatajson._id}/${Order._id}`}
            >
              Order Info
            </Link>
          </div>
        </div>

        {Order.agentId && typeof Order.agentId === "object" && (
          <div className="d-flex align-items-center gap-2 flex-wrap bg-white border rounded p-2">
            <img
              src={getDriverProfileImage(Order.agentId)}
              alt={Order.agentId?.username || "Driver"}
              className="rounded-circle border"
              style={{ width: 46, height: 46, objectFit: "cover" }}
              onError={(e) => {
                e.currentTarget.src = "/assets/img/user.svg";
              }}
            />

            <div className="flex-grow-1">
              <div className="fw-semibold text-dark">
                {Order.agentId?.username || "Driver Assigned"}
              </div>
              <div className="small text-muted">
                {Order.agentId?.phone ? `+91 ${Order.agentId.phone}` : "Phone not available"}
              </div>
            </div>

            <div className="badge-soft badge-mode text-uppercase ms-auto">
              <i className="ri-star-fill me-1 text-warning" />
              {getDriverRating(Order.agentId).label}
            </div>
          </div>
        )}

        <div className="progressbar-track order-progress">
          <ul className="progressbar modern-progress">
            <li className={`step ${parseInt(Order.status) >= 1 ? "done" : ""}`} title="Placed">
              <span className="dot"><i className="ri-circle-fill" /></span>
              <span className="label">Placed</span>
            </li>

            <li className={`step ${parseInt(Order.status) >= 2 ? "done" : ""}`} title="Accepted">
              <span className="dot"><i className="ri-circle-fill" /></span>
              <span className="label">Driver Asign</span>
            </li>

            <li className={`step ${parseInt(Order.status) >= 5 ? "done" : ""}`} title="Started">
              <span className="dot"><i className="ri-circle-fill" /></span>
              <span className="label">Ongoing</span>
            </li>

            <li className={`step ${parseInt(Order.status) >= 7 ? "done" : ""}`} title="Completed">
              <span className="dot"><i className="ri-circle-fill" /></span>
              <span className="label">Completed</span>
            </li>
          </ul>
          <div id="tracker" />
        </div>

      </div>
    </div>

  </div>
</div>


                      </React.Fragment>
                    ))
                    )}

 
              </div>
 
 </main>




    </>
  )
}

export default Account
